import { RECOMMENDED_MARKETING_HUB, RECOMMENDED_SALES_HUB, RECOMMENDED_SERVICE_HUB, RECOMMENDED_CMS_HUB, RECOMMENDED_OPS_HUB, RECOMMENDED_UNSPECIFIED_HUB } from './RecommendedHubs';
import { MARKETING_HUB_PROFESSIONAL, SALES_HUB_PROFESSIONAL, SERVICE_HUB_PROFESSIONAL, CMS_HUB_PROFESSIONAL, OPERATIONS_HUB_PROFESSIONAL } from './ApiNames';
const recommendedHubToApiNameMap = {
  [RECOMMENDED_MARKETING_HUB]: MARKETING_HUB_PROFESSIONAL,
  [RECOMMENDED_SALES_HUB]: SALES_HUB_PROFESSIONAL,
  [RECOMMENDED_SERVICE_HUB]: SERVICE_HUB_PROFESSIONAL,
  [RECOMMENDED_CMS_HUB]: CMS_HUB_PROFESSIONAL,
  [RECOMMENDED_OPS_HUB]: OPERATIONS_HUB_PROFESSIONAL,
  [RECOMMENDED_UNSPECIFIED_HUB]: MARKETING_HUB_PROFESSIONAL
};
export default recommendedHubToApiNameMap;